module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.65f9c63a.woff";